import { render, staticRenderFns } from "./FormPQRS.vue?vue&type=template&id=0528b70a&scoped=true&"
var script = {}
import style0 from "./FormPQRS.vue?vue&type=style&index=0&id=0528b70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528b70a",
  null
  
)

export default component.exports